import React, { createContext, useContext, ReactNode } from 'react';
import { useGlobalStorage } from '../hooks/useGlobalStorage';

type GlobalStorageContextType = ReturnType<typeof useGlobalStorage>;

const GlobalStorageContext = createContext<GlobalStorageContextType | undefined>(undefined);

export const GlobalStorageProvider = ({ children }: { children: ReactNode }) => {
  const globalStorage = useGlobalStorage();
  
  return (
    <GlobalStorageContext.Provider value={globalStorage}>
      {children}
    </GlobalStorageContext.Provider>
  );
};

export const useGlobalStorageContext = () => {
  const context = useContext(GlobalStorageContext);
  if (context === undefined) {
    throw new Error('useGlobalStorageContext must be used within a GlobalStorageProvider');
  }
  return context;
};
